/** Weergavelogica voor bekendmakingen, los van React zodat hij te testen is. */

/** "12 september 2026" — bekendmakingen worden op datum besproken. */
export const datum = (iso: string | null) =>
  iso
    ? new Date(iso).toLocaleDateString("nl-NL", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    : "";

/**
 * Afstand pas noemen als hij iets toevoegt: "op het perceel" is informatief,
 * "op 3 meter" suggereert een precisie die de bron niet heeft — het is het
 * gepubliceerde gebied, niet de exacte plek van de ingreep.
 */
export const afstand = (meter: number | null) => {
  if (meter === null) return "";
  if (meter < 25) return "op het perceel";
  if (meter < 1000) return `${Math.round(meter / 10) * 10} m`;
  return `${(meter / 1000).toFixed(1)} km`;
};
